// Cache-busting token for the probe requests whose whole point is that they must reach the network
// rather than a cache (dnsLeak.ts, dualStackLeak.ts).
//
// This exists because these call sites used crypto.randomUUID() directly, and randomUUID is exposed
// only in secure contexts: on a page served over plain http:// it is undefined, so the call threw and
// took the entire probe down with it — the DNS-leak and IPv4/IPv6 tiles both reported "unavailable"
// with no way to tell that from a genuinely unreachable probe host. A cache-buster must never be able
// to fail a check. crypto.getRandomValues has no secure-context requirement and covers everything
// randomUUID is missing from; Math.random is the last resort, which is entirely acceptable here —
// nothing about this value is a security boundary, it only has to differ between requests.
export function requestNonce(): string {
  if (typeof crypto !== "undefined") {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();

    if (typeof crypto.getRandomValues === "function") {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
    }
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
